import { render } from "./BlogPreview.vue?vue&type=template&id=2501871f&scoped=true"
import script from "./BlogPreview.vue?vue&type=script&lang=js"
export * from "./BlogPreview.vue?vue&type=script&lang=js"

import "./BlogPreview.vue?vue&type=style&index=0&id=2501871f&scoped=true&lang=css"

import exportComponent from "C:\\code repo\\iebrewers.org\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2501871f"]])

export default __exports__